import { sortBy, uniq } from "lodash";
import { B2FileInfo } from "source/app/services/Sound/Music/BackBlazeFilePath";

export function GetSuggestionsFromB2FileInfos(
    allFileInfos: B2FileInfo[],
    property: keyof B2FileInfo,
    additionalValuesToInclude?: string[]
) {
    const allValues = allFileInfos.map((fileInfo) => fileInfo[property]);
    const uniqueValues = uniq(allValues);

    const combinedValues = [
        ...uniqueValues,
        ...(additionalValuesToInclude || []),
    ];

    const sortedValues = sortBy(combinedValues);
    return sortedValues;
}
